// File: EVOLVE/Projects/cristTools/client/src/features/financial/financialSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../../apis/axiosConfig';

const initialState = {
  accounts: [],
  transactions: [],
  investments: [],
  loading: false,
  error: null
};

export const fetchAccounts = createAsyncThunk(
  'financial/fetchAccounts',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(process.env.REACT_APP_FINANCIAL_EXTENDED_NEURO_URL +'/accounts');
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const financialSlice = createSlice({
  name: 'financial',
  initialState,
  reducers: {
    clearFinancialData: (state) => {
      state.accounts = [];
      state.transactions = [];
      state.investments = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAccounts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAccounts.fulfilled, (state, action) => {
        state.loading = false;
        state.accounts = action.payload;
      })
      .addCase(fetchAccounts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearFinancialData } = financialSlice.actions;
export default financialSlice.reducer;